module.exports = __webpack_public_path__ + "img/time_circle.4c327093.svg";